import React from "react";
import TextInput from "../../FormItems/TextInput.jsx";
import SelectInput from "../../FormItems/SelectInput.jsx";

const US_STATES = [
  { value: "", text: "Select" },
  { value: "AL", text: "AL" },
  { value: "AK", text: "AK" },
  { value: "AZ", text: "AZ" },
  { value: "AR", text: "AR" },
  { value: "CA", text: "CA" },
  { value: "CO", text: "CO" },
  { value: "CT", text: "CT" },
  { value: "DE", text: "DE" },
  { value: "FL", text: "FL" },
  { value: "GA", text: "GA" },
  { value: "HI", text: "HI" },
  { value: "ID", text: "ID" },
  { value: "IL", text: "IL" },
  { value: "IN", text: "IN" },
  { value: "IA", text: "IA" },
  { value: "KS", text: "KS" },
  { value: "KY", text: "KY" },
  { value: "LA", text: "LA" },
  { value: "ME", text: "ME" },
  { value: "MD", text: "MD" },
  { value: "MA", text: "MA" },
  { value: "MI", text: "MI" },
  { value: "MN", text: "MN" },
  { value: "MS", text: "MS" },
  { value: "MO", text: "MO" },
  { value: "MT", text: "MT" },
  { value: "NE", text: "NE" },
  { value: "NV", text: "NV" },
  { value: "NH", text: "NH" },
  { value: "NJ", text: "NJ" },
  { value: "NM", text: "NM" },
  { value: "NY", text: "NY" },
  { value: "NC", text: "NC" },
  { value: "ND", text: "ND" },
  { value: "OH", text: "OH" },
  { value: "OK", text: "OK" },
  { value: "OR", text: "OR" },
  { value: "PA", text: "PA" },
  { value: "RI", text: "RI" },
  { value: "SC", text: "SC" },
  { value: "SD", text: "SD" },
  { value: "TN", text: "TN" },
  { value: "TX", text: "TX" },
  { value: "UT", text: "UT" },
  { value: "VT", text: "VT" },
  { value: "VA", text: "VA" },
  { value: "WA", text: "WA" },
  { value: "WV", text: "WV" },
  { value: "WI", text: "WI" },
  { value: "WY", text: "WY" },
];

const Step3 = ({ formData, updateField, goNext, goPrev }) => {
  const handleChange = name => e => {
    updateField(name, e.target.value);
  };

  const skip = () => {
    goNext();
  };

  return (
    <div className="form-order-services__step form-order-services__step--3">
      <h2 className="form-order-services__step-title txt-h4">
        Tell us about the Subject Property
      </h2>

      {/* Row 1: Street Number / Street Name */}
      <div className="form-order-services__column-container">
        <div className="form-order-services__column">
          <TextInput
            label="Street Number"
            name="propertyStreetNum"
            value={formData.propertyStreetNum}
            onChange={handleChange("propertyStreetNum")}
          />
        </div>
        <div className="form-order-services__column">
          <TextInput
            label="Street Name"
            name="propertyStreetName"
            value={formData.propertyStreetName}
            onChange={handleChange("propertyStreetName")}
          />
        </div>
      </div>

      {/* Row 2: City / State */}
      <div className="form-order-services__column-container">
        <div className="form-order-services__column">
          <TextInput
            label="City"
            name="propertyCity"
            value={formData.propertyCity}
            onChange={handleChange("propertyCity")}
          />
        </div>
        <div className="form-order-services__column">
          <SelectInput
            label="State/Province"
            name="propertyState"
            value={formData.propertyState}
            onChange={e => updateField("propertyState", e.target.value)}
            options={US_STATES.map(s => ({ value: s.value, text: s.text }))}
            placeholder="Select"
            errorMsg=""
          />
        </div>
      </div>

      {/* Row 3: Zip / County */}
      <div className="form-order-services__column-container">
        <div className="form-order-services__column">
          <TextInput
            label="Zip"
            name="propertyZip"
            value={formData.propertyZip}
            onChange={handleChange("propertyZip")}
          />
        </div>
        <div className="form-order-services__column">
          <TextInput
            label="County"
            name="propertyCounty"
            value={formData.propertyCounty}
            onChange={handleChange("propertyCounty")}
          />
        </div>
      </div>

      {/* Row 4: Unit Number / Tax Parcel */}
      <div className="form-order-services__column-container">
        <div className="form-order-services__column">
          <TextInput
            label="Unit Number"
            name="propertyUnitNumber"
            value={formData.propertyUnitNumber}
            onChange={handleChange("propertyUnitNumber")}
          />
        </div>
        <div className="form-order-services__column">
          <TextInput
            label="Tax Parcel Number"
            name="propertyTaxParcelNumber"
            value={formData.propertyTaxParcelNumber}
            onChange={handleChange("propertyTaxParcelNumber")}
          />
        </div>
      </div>

      {/* Row 5: Legal Description (full width) */}
      <div className="form-order-services__column-container">
        <div
          className="form-order-services__column"
          style={{ flex: "1 1 100%" }}
        >
          <label
            className="form-order-services__group-label"
            htmlFor="property_legal_description"
          >
            Legal Description
          </label>
          <textarea
            id="propertyDesc"
            className="form-order-services__textarea"
            rows={5}
            value={formData.propertyDesc}
            onChange={handleChange("propertyDesc")}
          />
        </div>
      </div>

      <div className="form-order-services__actions">
        <button type="button" className="btn btn--secondary" onClick={goPrev}>
          BACK
        </button>
        <div className="form-order-services__actions-group">
          <button type="button" className="btn btn--secondary" onClick={skip}>
            SKIP
          </button>
          <button type="button" className="btn btn--primary" onClick={goNext}>
            NEXT
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step3;
